import { Box, Divider, Grid, List, ListItem, ListItemText, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core'
import React, { Fragment } from 'react'
import Anexa1ACererePF from '../Dosar/Anexe/Anexa1ACererePF'
import PF_PJ from '../Dosar/Common/PF_PJ'


const Text = ({children}) => <Typography variant="body1"  component="span" style={{fontWeight:800}} color="secondary">{children}</Typography>
 
export default function ImportedPresentationTpl({data}) {
  return (
    <Fragment>
        {data && (
            <Box sx = {{ p:2, m:2}}>

                     <Divider/>
                       <Text> Tip Cerere: </Text>{data?.ofertanti[0].tip ? "PF" : "PJ"} 
                        <br/>
                        <Text>Ofertanți:</Text>
                            <PF_PJ data = {data.ofertanti} />
                        <br/>
                        <Text>Documente cerere:</Text>
                            <ul style = {{margin:0}}>
                            {data?.documenteCerere?.map((e,i)=>(
                                <li key={i}>{e}</li>
                            ))}
                            {!data?.documenteCerere && <> n / a</>}
                            </ul>
                   <Divider/>
                    <Text>Preemptori:</Text>
                         <ul style = {{margin:0}}>
                            {data?.anexe?.preemptoriCerere?.map((e,i)=>(
                                <li key={i}>{e.name} - rang: {e.rangId}</li>
                            ))}
                            {data?.anexe?.preemptoriCerere.length === 0 && <> n / a</>}
                            </ul>
                    <Divider/>
                    <Text>Litigii/sarcini:</Text>
                    <br/>
                    Litigii: <strong>{data?.anexe?.litigii ? "DA": "NU"}</strong><br/>
                    Sarcini: <strong>{data?.anexe?.sarcini ? "DA": "NU"}</strong>
                    
                    <Divider/>
                    <Text>Teren:</Text>
                    <Table style = {{border: "2px solid black"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Supr(ha)</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Cota</strong></TableCell>
                                
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Loc.</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Jud.</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Nr.cad.</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Nr.CF</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Loc.CF</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Tarla</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Parcela</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Lot</strong></TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}><strong>Categ.</strong></TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenHa}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.cotaParte}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>
                                    {data?.anexe?.terenLoc}
                                </TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>
                                    {data?.anexe?.terenJud}
                                    </TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenNrCadastral}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenCf}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenCfLoc}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenTarlaLot}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenParcela}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenTarlaLot}</TableCell>
                                <TableCell style ={{border:"1px solid black", textAlign:"center"}}>{data?.anexe?.terenCategorie}</TableCell>

                            </TableRow>
                        </TableBody>
                    </Table>
                    <Divider/>
                    <Text>Condiții:</Text> {data?.anexe?.terenConditii}<br/>
                    <Text>Prețul:</Text> {data?.anexe?.terenPret} lei
            </Box>
        )}
    </Fragment>
  )
}
